import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';
import { toPng } from 'html-to-image';

export const useQRCodePdfFilePreview = (name?: string) => {
  const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
  const pdfFileName = name ? `QRCode_${name}.pdf` : 'QRCode.pdf';

  const downloadQRCodeAsPdf = async () => {
    const input = document.getElementById('divToPrint');
    let imageUri: any;

    if (isSafari) {
      imageUri = await html2canvas(input as any, { scale: 3 });
    } else {
      imageUri = await toPng(input as any, { quality: 1, pixelRatio: 3 });
    }

    const pdf = new jsPDF();

    pdf.addImage(imageUri, 'PNG', 0, 0, 0, 0);
    pdf.save(pdfFileName);
  };

  return {
    downloadQRCodeAsPdf,
  };
};
